import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AdmissionsAreaService } from '../../../../admissions/admissions-area.service';
import { AdmissionsAcceleratorsService } from '../../admissions-accelerators.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'admissions-accelerators-accelerators-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './accelerators-view.part.html',
})
export class AdmissionsAcceleratorsViewPart {

	private readonly util = inject(UtilityService);
	private readonly router = inject(Router);
	public readonly admissionsAreaService = inject(AdmissionsAreaService);
	private readonly pageService = inject(AdmissionsAcceleratorsService);

	public setup = getSetup(this.util, this.admissionsAreaService.app, this.router);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public accelerators = computed(() => {
		const accelerators = this.admissionsAreaService.admissionsData()?.accelerators;
		if (!accelerators) return [];

		return accelerators.map(a => {
			const formattedData = this.util.date.formatAccMeetingSlot(a.meetingStartSlot, a.standardFourTimeZoneId, true, this.admissionsAreaService.app.data().standardLocalTimezoneId)
			return {
				...a,
				meetingLocalDisplayText: formattedData.localDisplayTime,
				meetingAcceleratorDisplayText: formattedData.acceleratorDisplayTime
			};
		})
	});
}